import {ApiCollection} from "./api.collection";
import {CustomAPI} from '../models/custom-apis.model';

export const CustomAPIs = ApiCollection.extend({
    model: CustomAPI,
    url: 'api/custom_apis',
});
